module.exports = __webpack_public_path__ + "static/img/8.bca4aa07.png";